/*!
 * Buttplug JS Source Code File - Visit https://buttplug.io for more info about
 * the project. Licensed under the BSD 3-Clause license. See LICENSE file in the
 * project root for full license information.
 *
 * @copyright Copyright (c) Nonpolynomial Labs LLC. All rights reserved.
 */
"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtplugBrowserWebsocketClientConnector = void 0;
const MessageUtils_1 = require("../core/MessageUtils");
const ButtplugMessageSorter_1 = require("../utils/ButtplugMessageSorter");
const ButtplugBrowserWebsocketConnector_1 = require("../utils/ButtplugBrowserWebsocketConnector");
class ButtplugBrowserWebsocketClientConnector extends ButtplugBrowserWebsocketConnector_1.ButtplugBrowserWebsocketConnector {
    constructor(_url) {
        super(_url);
        this._sorter = new ButtplugMessageSorter_1.ButtplugMessageSorter(true);
        this.Send = (aMsg) => __awaiter(this, void 0, void 0, function* () {
            if (!this.Connected) {
                throw new Error("ButtplugClient not connected");
            }
            const p = this._sorter.PrepareOutgoingMessage(aMsg);
            this.SendMessage(aMsg);
            return yield p;
        });
        this.ParseIncomingMessage = (aEvent) => {
            if (typeof (aEvent.data) === "string") {
                const msgs = MessageUtils_1.FromJSON(aEvent.data);
                const emitMsgs = this._sorter.ParseIncomingMessages(msgs);
                this.emit("message", emitMsgs);
            }
            else if (aEvent.data instanceof Blob) {
                const reader = new FileReader();
                reader.addEventListener("load", (ev) => { this.OnReaderLoad(ev); });
                reader.readAsText(aEvent.data);
            }
        };
    }
    get Connected() {
        return this._ws !== undefined;
    }
    OnReaderLoad(aEvent) {
        const msgs = MessageUtils_1.FromJSON(aEvent.target.result);
        const emitMsgs = this._sorter.ParseIncomingMessages(msgs);
        this.emit("message", emitMsgs);
    }
}
exports.ButtplugBrowserWebsocketClientConnector = ButtplugBrowserWebsocketClientConnector;
//# sourceMappingURL=ButtplugBrowserWebsocketClientConnector.js.map